import { DUPLICATION_WARNING, useDuplicationStore } from '../../stores';
import { useReloadSkillDiscovery } from './useReloadSkillDiscovery';

interface UseDuplicationWarning {
  showDuplicationWarning: (type: DUPLICATION_WARNING) => Promise<void>;
}

export const useDuplicationWarning = (): UseDuplicationWarning => {
  const reloadTree = useReloadSkillDiscovery();
  const setDuplicationWarning = useDuplicationStore(
    state => state.setDuplicationWarning,
  );

  const showDuplicationWarning = async (
    type: DUPLICATION_WARNING,
  ): Promise<void> => {
    reloadTree.reloadSkillDiscovery();
    setDuplicationWarning(type);
  };

  return { showDuplicationWarning };
};
